import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const PythonTema6 = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/Tema6_Aspectos_Avanzados.pdf`;
  /*const pdfUrl = "/pdf/Tema6_Aspectos_Avanzados.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Tema 6: Aspectos Avanzados</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Tema 6: Aspectos Avanzados" />
      </Container>
    </>
  );
};

 export default PythonTema6;
